import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../../App";
import { action, API, controller } from "../../../../../api/api";
import { InputAuto } from "../../../../../controls";
import { Dialog } from "../../../../../layout";
import AddEditBrand from "../../../Brand/AddEditBrand";

const InputBrand = ({
  values,
  setValues,
  errors,
  handleInpChg,
  size = "small",
}) => {
  const { authUser } = useContext(AppContext);
  const [brands, setBrands] = useState([]);

  const [newAddingValue, setNewAddingValue] = useState("");
  const [showBrandForm, setShowBrandForm] = useState(false);

  // Get Brand
  useEffect(() => {
    if (authUser.id) {
      API(controller.Brand + action.GetAllByOrg).get((res) => {
        res.status === 200 &&
          setBrands([...res.result.map((j) => ({ ...j, label: j.name }))]);
      });
    }
    return () => {};
  }, [authUser]);

  const handleAddNewBrand = (val) => {
    setNewAddingValue(val);
    setShowBrandForm(!showBrandForm);
  };
  const handleNewBrand = (brand) => {
    if (brand) {
      setBrands([{ ...brand, label: brand.name }, ...brands]);
      setValues((j) => ({ ...j, brandId: brand.id }));
      setNewAddingValue("");
    }
  };

  return (
    <>
      <InputAuto
        label="Brand"
        name="brandId"
        required={true}
        value={values.brandId}
        error={errors?.brandId}
        onChange={handleInpChg}
        options={brands}
        enableAddBtn={true}
        handleAdd={handleAddNewBrand}
        size={size}
      />

      {/* Add new brand */}
      {showBrandForm && (
        <Dialog show={showBrandForm} onClose={false} maxWidth="xs">
          <AddEditBrand
            {...{
              setShowForm: setShowBrandForm,
              openFromOtherSide: true,
              brandName: newAddingValue,
              handleResult: handleNewBrand,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default InputBrand;
